import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import Test from './Test'

export default compose(
  withType({ type: 'BOTTest' })
)(Test)
